import React from 'react';
import PropTypes from 'prop-types';
import { Text, Button, Box } from 'components/elements';
import { spacing } from 'theme';
import { separateText, mapObjectToArray } from './helpers';
import IconCard from '../iconCard/IconCard';
import * as S from './styles';

const motivationsMap = {
  being_part_of_something: {
    text: 'Be part of something',
    icon: 'part_of_something',
  },
  developing_relationships: {
    text: 'Make friends',
    icon: 'friends',
  },
  exercising_values_and_beliefs: {
    text: 'Give something back',
    icon: 'give_back',
  },
  having_influence: {
    text: 'Make a difrence',
    icon: 'difference',
  },
  helping_others: {
    text: 'Help others',
    icon: 'help',
  },
  personal_benefit: {
    text: 'learn new skills',
    icon: 'learn',
  },
};

function OppDescription({ data }) {
  const { summary, body, motivations, additionalInformation } = data;
  const [isOpen, setisOpen] = React.useState(false);

  function toggleOpen() {
    setisOpen((prevState) => !prevState);
  }

  const showMotivations = Object.values(motivations).some((value) => value === true);
  const showAdditionalInformation = isOpen && additionalInformation;

  return (
    <S.TextWrapper>
      {summary && (
        <Text variant="body1Bold" colour="primary.700" lineHeight="1.3">
          {`${summary}\n\n`}
        </Text>
      )}

      {body &&
        separateText(body).map((paragraph, index) => (
          <React.Fragment key={paragraph}>
            {index % 2 !== 0 ? (
              <>
                {isOpen && (
                  <Text variant="body1" lineHeight="1.3">
                    {paragraph}
                  </Text>
                )}
              </>
            ) : (
              <Text variant="body1" lineHeight="1.3">
                {paragraph}
              </Text>
            )}
          </React.Fragment>
        ))}
      {isOpen && showMotivations && (
        <>
          <Text as="h3" variant="body2Bold" colour="neutral.700">
            You will love this if you are looking to...
          </Text>
          <S.IconsWrapper>
            {mapObjectToArray(motivations, motivationsMap).map((motivation) => (
              <IconCard iconName={motivation.icon} text={motivation.text} key={motivation.text} />
            ))}
          </S.IconsWrapper>
        </>
      )}

      {showAdditionalInformation ? (
        <Box
          marginTop={28}
          cssOverrides={{
            '& > * + *': {
              marginTop: spacing[16],
            },
          }}
        >
          {separateText(additionalInformation).map((paragraph) => (
            <Text key={paragraph} variant="body1" lineHeight="1.3" colour="neutral.700">
              {paragraph}
            </Text>
          ))}
        </Box>
      ) : null}

      {
        <Button
          variant="ghost"
          size="xs"
          handleClick={() => toggleOpen()}
          label={isOpen ? 'Read Less' : 'Read More'}
        />
      }
    </S.TextWrapper>
  );
}

OppDescription.propTypes = {
  data: PropTypes.shape({
    summary: PropTypes.string,
    body: PropTypes.string,
    motivations: PropTypes.shape({}),
    additionalInformation: PropTypes.string,
  }).isRequired,
};

export default OppDescription;
